export async function submitRestrictions(projectId, userId, resourceObjectIdToRoleMap) {
  // clean up mapping
  const mapping = Object.fromEntries(Object.entries(resourceObjectIdToRoleMap).filter(([_, value]) => !!value));

  const response = await fetch(`/api/projects/${projectId}/users/${userId}/restrictions`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({resourceObjectIdToRoleMap: mapping}),
  })
  return response.ok
}
